import { Form, message } from 'antd'
import type { UploadFile } from 'antd/es/upload/interface'
import { Button, Input, TextField } from 'components/atoms'
import { MaskedInput } from 'components/atoms/Input/components'
import { MessagesNotification } from 'components/atoms/MessagesNotification'
import {
  SForm,
  SFromItem,
} from 'components/atoms/SendComment/style/SendComment.styled'
import { UploadFiles } from 'components/atoms/UploadFile'
import { DEFAULT_NOTIFICATION_CLOSE_TIMER } from 'numberConsts/numberConsts'
import { useCallback, useEffect, useState } from 'react'
import { MESSAGE_SUCCESS } from 'textConsts/textConsts'

import { postFeedback } from '../../../../../axios/axios'
import {
  SAdviceForm,
  SButtonWrapp,
  STitleFeedbackForm,
  STittleWrap,
  SWrapp,
  SWrapperModal,
} from '../components.styled'

export const Feedback = () => {
  const [form] = Form.useForm()
  const [files, setFiles] = useState<UploadFile[]>([])
  const [canSubmit, setCanSubmit] = useState(false)
  const onChangeFiles = useCallback((filesData: UploadFile[]) => {
    setFiles(filesData)
  }, [])

  const [isResponseReceived, setIsResponseReceived] = useState<boolean>()
  const [visibleMessage, setVisibleMessage] = useState(false)

  const postUserFeedback = useCallback(
    async (data: Record<string, string>) => {
      try {
        const body = new FormData()
        Object.entries(data).forEach(([key, value]) => body.append(key, value))
        files.forEach((file, index) => {
          const attachment =
            file.originFileObj || (file instanceof File ? file : null)
          if (attachment) {
            body.append(`file_${index}`, attachment, file.name)
          }
        })
        const res = await postFeedback.postFeedbackUser(body)
        const { success } = res.data
        setIsResponseReceived(success)
        if (!success) message.error('Не удалось отправить сообщение')
      } catch (e) {
        console.error(e)
        message.error('Не удалось отправить сообщение')
      }
    },
    [files],
  )

  const onFinish = useCallback(
    (data: unknown) => {
      postUserFeedback(data as Record<string, string>)
    },
    [postUserFeedback],
  )

  const onValuesChange = useCallback((_: unknown, rawValues: unknown) => {
    const values = rawValues as Record<string, string>
    const validPhone = /^\+7\(\d{3}\)-\d{3}-\d{2}-\d{2}$/.test(
      values.phone || '',
    )
    const validEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email || '')
    setCanSubmit(
      validPhone &&
        validEmail &&
        !!values.subject?.trim() &&
        !!values.message?.trim(),
    )
  }, [])

  useEffect(() => {
    let timeOut: NodeJS.Timeout
    if (isResponseReceived) {
      setVisibleMessage((prev) => !prev)
      timeOut = setTimeout(() => {
        setVisibleMessage((prev) => !prev)
      }, DEFAULT_NOTIFICATION_CLOSE_TIMER)
    }
    return () => clearTimeout(timeOut)
  }, [isResponseReceived])

  return (
    <SWrapp>
      <STittleWrap>Обратная связь</STittleWrap>
      <SWrapperModal>
        <SForm
          form={form}
          name="basic"
          layout="vertical"
          onFinish={onFinish}
          onValuesChange={onValuesChange}
          autoComplete="off">
          <SFromItem
            name="phone"
            label="Мобильный телефон"
            rules={[
              {
                required: true,
                pattern: /^\+7\(\d{3}\)-\d{3}-\d{2}-\d{2}$/,
                message: 'Укажите телефон полностью',
              },
            ]}>
            <MaskedInput mask="+7(000)-000-00-00" />
          </SFromItem>
          <SFromItem
            name="email"
            label="Электронная почта"
            rules={[
              {
                required: true,
                type: 'email',
                message: 'Укажите корректную почту',
              },
            ]}>
            <Input />
          </SFromItem>
          <SFromItem
            name="subject"
            label="Тема сообщения"
            rules={[
              { required: true, whitespace: true, message: 'Укажите тему' },
            ]}>
            <Input />
          </SFromItem>
          <SFromItem
            name="message"
            label="Текст сообщения"
            rules={[
              {
                required: true,
                whitespace: true,
                message: 'Введите сообщение',
              },
            ]}>
            <TextField width="200px" />
          </SFromItem>
          <STitleFeedbackForm>Загрузите файлы</STitleFeedbackForm>
          <UploadFiles onChangeCallback={onChangeFiles} />
          <SAdviceForm>Максимальный размер файла - 5 Mb</SAdviceForm>
          <Form.Item>
            <SButtonWrapp>
              <Button htmlType="submit" disabled={!canSubmit}>
                Отправить
              </Button>
            </SButtonWrapp>
          </Form.Item>
        </SForm>
      </SWrapperModal>
      <MessagesNotification
        message={MESSAGE_SUCCESS}
        open={visibleMessage}
        title="Уведомление"
        type="success"
      />
    </SWrapp>
  )
}
